import { Component, Input, ViewChild } from '@angular/core'
import { GridQuickFilterServiceDirective, IFilterOption, IQuickFilter } from '@exchange/domain/.'

@Component({
  selector: 'app-grid-quick-filter',
  templateUrl: './grid-quick-filter.component.html',
  styleUrls: ['./grid-quick-filter.component.scss'],
  standalone: false
})
export class GridQuickFilterComponent {
  @ViewChild('filterElement', { static: true }) filterElement: any
  defaultFilterType: IFilterOption = null
  selectedFilterType: IFilterOption = null
  filter = ''

  _filterTypes: IFilterOption[] = []

  constructor(private gridQuickFilterServiceDirective: GridQuickFilterServiceDirective) {}

  get filterTypes(): IFilterOption[] {
    return this._filterTypes
  }

  @Input()
  set filterTypes(m: IFilterOption[]) {
    this._filterTypes = m
    this.defaultFilterType = this.filterTypes.find(x => x.default) || null
    this.selectedFilterType = this.defaultFilterType
  }

  createODataFilter(filterType: IFilterOption, filter) {
    let result = ''
    const filterValue = filterType.type !== 'number' ? `'${filter}'` : filter

    switch (filterType.operation) {
      case 'startswith':
        result = `startswith(cast(${filterType.fieldName}, Edm.String, '${filter}')`
        break
      case 'endswith':
        result = `endswith(cast(${filterType.fieldName}, Edm.String), '${filter}')`
        break
      case 'contains':
        result = `contains(cast(${filterType.fieldName}, Edm.String), '${filter}')`
        break
      default:
        result = `${filterType.fieldName} ${this.selectedFilterType.operation} ${filterValue}`
    }

    return result
  }

  searchClicked() {
    if (this.selectedFilterType && this.filter) {
      const qf = {
        fieldName: this.selectedFilterType.fieldName,
        operation: this.selectedFilterType.operation,
        filter: this.filter,
        odataFilter: this.createODataFilter(this.selectedFilterType, this.filter)
      } as IQuickFilter

      this.gridQuickFilterServiceDirective.search.emit(qf)
    } else if (this.selectedFilterType && this.filter === '') {
      this.resetClicked()
    }
  }

  resetClicked() {
    this.selectedFilterType = null
    this.selectedFilterType = this.defaultFilterType
    this.filter = ''
    this.gridQuickFilterServiceDirective.resetFilters.emit()
  }

  selectFilterType(type?: IFilterOption) {
    this.selectedFilterType = type
    this.filterElement.nativeElement.focus()
  }

  filter_keypress(event) {
    if (event.key === 'Escape') {
      this.resetClicked()
    }
    if (event.key === 'Enter') {
      this.searchClicked()
    }
  }
}
